/* Halo Water — native homepage controller. The PureFlow geometry is retained from the source page. */
(() => {
const t = window.HaloText;
class NativeComponent {
  constructor() { this.props = {}; this.state = {}; }
  setState(next, done) { Object.assign(this.state, next); this.syncDom(); done?.(); }
  syncDom() {
    this.site?.querySelectorAll('[data-hero-toggle]').forEach((button) => {
      button.hidden = !this.state.heroVideoReady;
      button.textContent = this.state.heroVideoPaused ? t('play') : t('pause');
      button.setAttribute('aria-label', this.state.heroVideoPaused ? t('play_hero') : t('pause_hero'));
    });
    this.site?.querySelectorAll('.halo-hero-media').forEach((media) => media.dataset.playing = String(this.state.heroVideoReady));
    this.site?.querySelectorAll('[data-results-toggle]').forEach((button) => {
      button.setAttribute('aria-pressed', String(this.state.resultsPaused));
      button.textContent = this.state.resultsPaused ? t('results_play') : t('results_pause');
      button.setAttribute('aria-label', this.state.resultsPaused ? t('play_results') : t('pause_results'));
    });
    this.site?.querySelectorAll('.halo-results-track').forEach((track) => track.dataset.paused = String(this.state.resultsPaused));
  }
}
class Component extends NativeComponent {
  state = { heroVideoReady: false, heroVideoPaused: true, resultsPaused: false, menuOpen: false };
  filterSceneRef = (section) => { this.filterSection = section; };
  filterFrame = 0;
  filterInView = false;
  filterStops = [.06, .35, .63, .94];
  selectFilterStep = (event) => {
    const index = Number(event.currentTarget.dataset.filterStep);
    if (!this.filterSection || this.filterStatic || !Number.isInteger(index) || index < 0 || index >= this.filterStops.length) return;
    const top = window.scrollY + this.filterSection.getBoundingClientRect().top;
    window.scrollTo({ top: top - this.filterTop + this.filterStops[index] * this.filterDistance, behavior: 'smooth' });
  };
  paintFilterScene(progress) {
    if (!this.filterSection) return;
    const ramp = (a, b) => { const t = Math.max(0, Math.min(1, (progress - a) / (b - a))); return t * t * (3 - 2 * t); };
    const carbon = ramp(.19, .25), head = ramp(.45, .51), water = ramp(.74, .80);
    const weights = this.filterStatic ? [1, 1, 1, 1] : [1 - carbon, carbon * (1 - head), head * (1 - water), water];
    const active = [.22, .48, .77].filter(t => progress >= t).length;
    if(this.filterActive !== active){
      if(this.filterActive != null && !this.filterDrag)this.filterYawTarget=this.filterYaw+Math.atan2(Math.sin(-this.filterYaw),Math.cos(-this.filterYaw));
      this.filterActive=active;this.filterSection.dataset.chapter=String(active);
    }
    this.filterSection.style.setProperty('--hf-progress', progress.toFixed(4));
    this.filterChapters.forEach((chapter, index) => {
      chapter.style.opacity = weights[index].toFixed(4);
      chapter.style.transform = this.filterStatic ? 'none' : 'translateY(' + ((1 - weights[index]) * 12).toFixed(2) + 'px)';
      chapter.style.visibility = weights[index] > .001 ? 'visible' : 'hidden';
      chapter.setAttribute('aria-hidden', String(!this.filterStatic && index !== active));
    });
    const edges = [0, .22, .48, .77, 1];
    this.filterButtons.forEach((button, index) => {
      button.style.setProperty('--hf-step-progress', Math.max(0, Math.min(1, (progress - edges[index]) / (edges[index + 1] - edges[index]))).toFixed(4));
      button.setAttribute('aria-pressed', String(index === active));
    });
    if (this.filter3D && !this.filterFailed) this.renderFilterModel(this.filterStatic ? .66 : progress);
  }
  rotateFilterView = (event) => {
    const direction=Number(event.currentTarget.dataset.filterTurn);
    if(direction !== -1 && direction !== 1)return;
    this.filterYawTarget += direction * Math.PI / 6;
    this.syncFilterScene();
  };
  resetFilterView = () => {
    this.filterYawTarget=this.filterYaw+Math.atan2(Math.sin(-this.filterYaw),Math.cos(-this.filterYaw));
    this.syncFilterScene();
  };
  toggleFilterWater = (event) => {
    this.filterWaterPaused=!this.filterWaterPaused;
    const label=this.filterWaterPaused?t('resume_water'):t('pause_water');
    event.currentTarget.setAttribute('aria-pressed',String(this.filterWaterPaused));
    event.currentTarget.setAttribute('aria-label',label);event.currentTarget.title=label;
    this.syncFilterScene();
  };
  tickFilterScene = (time=performance.now()) => {
    this.filterFrame=0;
    if(!this.filterSection || document.hidden)return;
    const rect=this.filterSection.getBoundingClientRect();
    const visible=rect.top<window.innerHeight && rect.bottom>this.filterTop;
    const target=this.filterStatic?.66:Math.max(0,Math.min(1,(this.filterTop-rect.top)/this.filterDistance));
    const dt=Math.min(48,Math.max(1,time-(this.filterLastTime??time-16)));
    this.filterLastTime=time;
    // Time-based damping removes wheel steps without changing the page's native scroll.
    const blend=this.filterStatic || !visible?1:1-Math.exp(-dt/115);
    this.filterProgress=this.filterProgress==null?target:this.filterProgress+(target-this.filterProgress)*blend;
    this.filterYaw+=(this.filterYawTarget-this.filterYaw)*blend;
    const moving=Math.abs(target-this.filterProgress)>.0001 || Math.abs(this.filterYawTarget-this.filterYaw)>.0001;
    if(!moving){this.filterProgress=target;this.filterYaw=this.filterYawTarget;}
    const flowing=visible && !this.filterStatic && !this.filterWaterPaused && !this.filterFailed && this.filterProgress>.77;
    if(flowing)this.filterClock+=dt/1000;
    this.paintFilterScene(this.filterProgress);
    if(visible && !this.filterStatic && (moving || flowing))this.filterFrame=requestAnimationFrame(this.tickFilterScene);
  };
  syncFilterScene = () => {
    if(!this.filterFrame && this.filterInView && !document.hidden)this.filterFrame=requestAnimationFrame(this.tickFilterScene);
  };
  measureFilterScene = () => {
    if (!this.filterSection || !this.filterStage) return;
    this.filterTop = this.filterHeader?.getBoundingClientRect().height ?? 0;
    this.filterSection.style.setProperty('--hf-top', this.filterTop + 'px');
    this.filterDistance = Math.max(1, this.filterSection.offsetHeight - this.filterStage.offsetHeight);
    if (this.filter3D) {
      const { renderer, camera } = this.filter3D;
      const width = Math.max(1, this.filterHost.clientWidth), height = Math.max(1, this.filterHost.clientHeight);
      if (width !== this.filterWidth || height !== this.filterHeight) {
        this.filterWidth = width; this.filterHeight = height;
        renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, width < 600 ? 1.5 : 1.75));
        renderer.setSize(width, height, false);
        const halfHeight = Math.max(3.35, 3.1 / (width / height));
        camera.left = -halfHeight * width / height; camera.right = -camera.left;
        camera.top = halfHeight; camera.bottom = -halfHeight;
        camera.updateProjectionMatrix();
        this.filterSection.querySelector('.hf-leaders')?.setAttribute('viewBox','0 0 '+width+' '+height);
        this.cacheFilterLabels();
      }
    }
    this.syncFilterScene();
  };
  configureFilterScene = () => {
    if (!this.filterSection) return;
    this.filterStatic = this.heroMotion.matches || this.filterCompact.matches || !!this.filterFailed || !this.filter3D;
    this.filterSection.dataset.enhanced = 'true';
    this.filterSection.dataset.static = String(this.filterStatic);
    this.filterSection.dataset.ready = String(!!this.filter3D && !this.filterFailed);
    window.cancelAnimationFrame(this.filterFrame);this.filterFrame=0;
    this.filterProgress=null;
    this.measureFilterScene();
    window.cancelAnimationFrame(this.filterFrame);this.filterFrame=0;
    this.tickFilterScene();
  };
  async loadFilterModel() {
    if (this.filterLoading || this.filter3D || this.filterFailed) return;
    this.filterLoading = true;
    const token = this.filterToken;
    try {
      const THREE = await import(this.filterModuleUrl);
      if (token !== this.filterToken) return;
      this.buildFilterModel(THREE);
      this.configureFilterScene();
    } catch (error) {
      if (token !== this.filterToken) return;
      this.disposeFilterModel();
      this.filterFailed = true;
      this.configureFilterScene();
      console.warn('PureFlow: showing the static cutaway because 3D is unavailable.', error);
    }
  }
  buildFilterModel(T) {
    const renderer = new T.WebGLRenderer({ antialias: true, alpha: true, powerPreference: 'low-power' });
    renderer.setClearColor(0x000000, 0);
    renderer.outputColorSpace = T.SRGBColorSpace;
    renderer.toneMapping = T.ACESFilmicToneMapping;
    renderer.toneMappingExposure = 1.15;
    const scene = new T.Scene();
    const camera = new T.OrthographicCamera(-5, 5, 3.35, -3.35, .1, 80);
    camera.position.set(0, .1, 14); camera.lookAt(0, .1, 0);
    const root = new T.Group(); scene.add(root);
    const s = this.filter3D = { T, renderer, scene, camera, root, textures: [], projected: new T.Vector3(), sample: new T.Vector3(), tangent: new T.Vector3(), up: new T.Vector3(0,1,0) };
    this.filterHost.appendChild(renderer.domElement);
    renderer.domElement.addEventListener('webglcontextlost', (event) => {
      event.preventDefault(); this.filterFailed = true; this.configureFilterScene();
    }, { signal: this.filterEvents.signal });
    renderer.domElement.addEventListener('webglcontextrestored', () => {
      this.filterFailed = false; this.configureFilterScene();
    }, { signal: this.filterEvents.signal });

    // Studio reflections are generated locally: no HDR, model, or texture downloads.
    const studio = new T.Scene(); studio.background = new T.Color(0x344562);
    [[-4, 3, 4, 5, 9, 0xF6F4E9, 4], [5, 1, 1, 3, 8, 0xD6E4FF, 3], [0, 6, -1, 8, 4, 0xFFFFFF, 3]].forEach(([x, y, z, w, h, color, strength]) => {
      const panel = new T.Mesh(new T.PlaneGeometry(w, h), new T.MeshBasicMaterial({ color: new T.Color(color).multiplyScalar(strength), side: T.DoubleSide }));
      panel.position.set(x, y, z); panel.lookAt(0, 0, 0); studio.add(panel);
    });
    const pmrem = new T.PMREMGenerator(renderer);
    s.environment = pmrem.fromScene(studio, .04);
    scene.environment = s.environment.texture;
    pmrem.dispose(); studio.traverse(o => { o.geometry?.dispose(); o.material?.dispose(); });
    scene.add(new T.HemisphereLight(0xE4EDFF, 0x142B55, 1.6));
    [[-3, 6, 5, 0xFFF4D9, 4], [4, 2, -3, 0x8FB8FF, 4], [2, -3, 4, 0xFFFFFF, 1]].forEach(([x, y, z, color, intensity]) => {
      const light = new T.DirectionalLight(color, intensity); light.position.set(x, y, z); scene.add(light);
    });
    const material = (color, metalness = .1, roughness = .4) => new T.MeshStandardMaterial({ color, metalness, roughness });
    const black = new T.MeshPhysicalMaterial({color:0x141C20,metalness:.22,roughness:.38,clearcoat:.12,clearcoatRoughness:.35});
    s.shellMaterial = black.clone(); s.shellMaterial.transparent = true;
    s.headMaterial = black.clone(); s.headMaterial.transparent = true;
    const silver = material(0xC4D0D1, .9, .23), polymer = material(0xE3E6DA, .08, .34);
    const graphite = material(0x111A1E, .08, .75), rubber = material(0x111C1C,0,.92);
    const mesh = (geometry, mat, parent = root, x = 0, y = 0, z = 0) => {
      const object = new T.Mesh(geometry, mat); object.position.set(x, y, z); parent.add(object); return object;
    };
    const instances=(geometry,mat,parent,count,place)=>{
      const batch=new T.InstancedMesh(geometry,mat,count),pose=new T.Object3D();
      for(let i=0;i<count;i++){place(pose,i);pose.updateMatrix();batch.setMatrixAt(i,pose.matrix);}
      parent.add(batch);return batch;
    };
    const ringGeometry = (outer, inner, depth, bevel = .018) => {
      const b = Math.min(bevel, depth / 3), h = depth / 2;
      const profile = new T.Path();
      profile.moveTo(inner + b, -h); profile.lineTo(outer - b, -h);
      profile.quadraticCurveTo(outer, -h, outer, -h + b); profile.lineTo(outer, h - b);
      profile.quadraticCurveTo(outer, h, outer - b, h); profile.lineTo(inner + b, h);
      profile.quadraticCurveTo(inner, h, inner, h - b); profile.lineTo(inner, -h + b);
      profile.quadraticCurveTo(inner, -h, inner + b, -h);
      return new T.LatheGeometry(profile.getPoints(10), 128).rotateX(Math.PI / 2);
    };
    const hoop = (radius, thickness, parent, z, mat = polymer) => mesh(new T.TorusGeometry(radius, thickness, 8, 96), mat, parent, 0, 0, z);
    const texture = (size, draw) => {
      const canvas = document.createElement('canvas'); canvas.width = canvas.height = size;
      draw(canvas.getContext('2d'), size);
      const map = new T.CanvasTexture(canvas); map.colorSpace = T.SRGBColorSpace; s.textures.push(map); return map;
    };
    const screen = texture(64, (ctx, size) => {
      ctx.fillStyle = '#000'; ctx.fillRect(0, 0, size, size); ctx.strokeStyle = '#fff'; ctx.lineWidth = 2;
      ctx.strokeRect(0, 0, size, size); ctx.beginPath(); ctx.moveTo(0, 32); ctx.lineTo(64, 32); ctx.moveTo(32, 0); ctx.lineTo(32, 64); ctx.stroke();
    });
    screen.colorSpace = T.NoColorSpace; screen.wrapS = screen.wrapT = T.RepeatWrapping; screen.repeat.set(13, 13);
    const micro=texture(128,(ctx,size)=>{
      const pixels=ctx.createImageData(size,size);let seed=419;
      for(let i=0;i<pixels.data.length;i+=4){seed=(Math.imul(seed,1664525)+1013904223)>>>0;const value=105+(seed%62);pixels.data[i]=pixels.data[i+1]=pixels.data[i+2]=value;pixels.data[i+3]=255;}
      ctx.putImageData(pixels,0,0);
    });
    micro.colorSpace=T.NoColorSpace;micro.wrapS=micro.wrapT=T.RepeatWrapping;micro.repeat.set(5,9);
    [black,s.shellMaterial,s.headMaterial].forEach(m=>{m.bumpMap=micro;m.bumpScale=.002;});


    // Handle casing and carbon cartridge share the same axis, as in the reference photos.
    s.handle = new T.Group(); root.add(s.handle);
    const profile = [[0,-1.42],[.23,-1.42],[.31,-1.38],[.33,-1.3],[.335,1.26],[.325,1.37],[.30,1.4],[0,1.4]].map(([r,y]) => new T.Vector2(r,y));
    const handle = mesh(new T.LatheGeometry(profile, 64), s.shellMaterial, s.handle, 0, -1.13, 0); handle.scale.z = .9;
    const connector = mesh(new T.CylinderGeometry(.21,.21,.18,48), silver, s.handle,0,-2.64,0); connector.scale.z=.9;
    for (let i=0;i<4;i++) { const thread=hoop(.205,.012,s.handle,0,silver); thread.rotation.x=Math.PI/2; thread.position.y=-2.59-i*.034; thread.scale.y=.9; }
    const logoMap = texture(256, (ctx) => { ctx.fillStyle='#F0F4FF'; ctx.font='500 54px sans-serif'; ctx.textAlign='center'; ctx.fillText('halo',128,140); });
    mesh(new T.PlaneGeometry(.34,.34), new T.MeshBasicMaterial({map:logoMap,transparent:true,opacity:.65,depthWrite:false}),s.handle,0,-1.88,.304);
    const neckCurve = new T.CatmullRomCurve3([[.31,.30,0],[.32,.49,0],[.36,.65,0],[.46,.85,0],[.39,1.03,0]].map(p => new T.Vector3(...p)));
    const neck = mesh(new T.LatheGeometry(neckCurve.getPoints(32).map(p => new T.Vector2(p.x,p.y)),64),black);
    neck.scale.z=.73;
    const seam=mesh(new T.CylinderGeometry(.328,.328,.018,64),graphite,root,0,.29,0);seam.scale.z=.9;
    const button=mesh(new T.CapsuleGeometry(.08,.13,4,12),material(0x364349,.4,.4),root,0,.58,-.32);button.scale.set(1.2,1,.45);

    s.carbon = new T.Group(); s.carbon.position.set(0,-1.12,0); root.add(s.carbon);
    const cageMat = material(0x8D9AAD,.48,.48);cageMat.alphaMap=screen;cageMat.alphaTest=.24;cageMat.side=T.DoubleSide;
    s.carbonSleeve=new T.Group();s.carbon.add(s.carbonSleeve);
    mesh(new T.CylinderGeometry(.25,.25,2.2,64,1,true),cageMat,s.carbonSleeve);
    const clearSleeve=new T.MeshPhysicalMaterial({color:0xD6E4FF,roughness:.2,metalness:.05,clearcoat:.5,transparent:true,opacity:.085,depthWrite:false});
    mesh(new T.CylinderGeometry(.257,.257,2.2,64,1,true),clearSleeve,s.carbonSleeve);
    instances(new T.CylinderGeometry(.004,.004,2.17,5),silver,s.carbonSleeve,6,(pose,i)=>{const a=i*Math.PI/3;pose.position.set(Math.cos(a)*.255,0,Math.sin(a)*.255);});
    for(const y of [-1.07,-.54,0,.54,1.07]){const rim=hoop(.253,.004,s.carbonSleeve,0,silver);rim.rotation.x=Math.PI/2;rim.position.y=y;}
    s.carbonCaps=[];
    for(const sign of [-1,1]){
      const cap=new T.Group();cap.position.y=sign*1.17;s.carbon.add(cap);s.carbonCaps.push(cap);
      mesh(ringGeometry(.27,.071,.14,.018),polymer,cap).rotation.x=Math.PI/2;
      const gasket=hoop(.241,.012,cap,0,rubber);gasket.rotation.x=Math.PI/2;gasket.position.y=-sign*.067;
      const lip=mesh(ringGeometry(.177,.078,.031,.007),polymer,cap,0,sign*.086,0);lip.rotation.x=Math.PI/2;
      instances(new T.BoxGeometry(.019,.018,.014),graphite,cap,16,(pose,i)=>{const a=i*Math.PI/8;pose.position.set(Math.cos(a)*.263,0,Math.sin(a)*.263);pose.rotation.y=-a;});
    }
    mesh(ringGeometry(.205,.068,2.19,.005),graphite,s.carbon).rotation.x=Math.PI/2;
    let seed=72;
    const random=()=>{seed=(Math.imul(seed,1664525)+1013904223)>>>0;return seed/4294967296;};
    const dummy=new T.Object3D();
    const grains = new T.InstancedMesh(new T.DodecahedronGeometry(1,0),material(0x26332E,.02,.94),1800);
    for(let i=0;i<1800;i++) {
      const angle=random()*Math.PI*2,r=.192+.020*random(),size=.012+random()*.020;
      dummy.position.set(Math.cos(angle)*r,(random()-.5)*2.18,Math.sin(angle)*r);dummy.rotation.set(random()*3,random()*3,random()*3);dummy.scale.set(size,size*.8,size*1.15);dummy.updateMatrix();grains.setMatrixAt(i,dummy.matrix);grains.setColorAt(i,new T.Color().setScalar(.45+random()*.4));
    }
    grains.material.bumpMap=micro;grains.material.bumpScale=.008;
    s.carbon.add(grains);

    s.head = new T.Group(); s.head.position.y=1.59;root.add(s.head);
    mesh(ringGeometry(1.015,.385,.07,.02),s.headMaterial,s.head,0,0,-.19);
    mesh(ringGeometry(1.015,.953,.28,.019),s.headMaterial,s.head,0,0,-.02);
    mesh(ringGeometry(.427,.385,.28,.01),s.headMaterial,s.head,0,0,-.02);
    for(const radius of [.53,.68,.83])hoop(radius,.007,s.head,-.145,rubber);
    instances(new T.BoxGeometry(.014,.36,.025),black,s.head,12,(pose,i)=>{const a=i*Math.PI/6;pose.position.set(Math.cos(a)*.688,Math.sin(a)*.688,-.128);pose.rotation.z=a-Math.PI/2;});
    s.seal=new T.Group();s.head.add(s.seal);hoop(.923,.026,s.seal,0,rubber);hoop(.408,.014,s.seal,0,rubber);
    hoop(1.038,.016,s.head,.08,silver);hoop(.381,.016,s.head,.09,silver);
    s.puck = new T.Group(); s.head.add(s.puck);
    // One annular head cartridge contains both media. The split is an illustrative cutaway.
    for(const z of [-.14,.14]){hoop(.904,.023,s.puck,z);hoop(.426,.018,s.puck,z);}
    instances(new T.CylinderGeometry(.004,.004,.27,4),polymer,s.puck,36,(pose,i)=>{const a=i*Math.PI/18;pose.position.set(Math.cos(a)*.901,Math.sin(a)*.901,0);pose.rotation.x=Math.PI/2;});
    for(const radius of [.904,.421]) {const wall=mesh(new T.CylinderGeometry(radius,radius,.28,96,1,true),new T.MeshStandardMaterial({color:0xD6E4FF,metalness:.1,roughness:.3,transparent:true,opacity:.22,side:T.DoubleSide,depthWrite:false}),s.puck);wall.rotation.x=Math.PI/2;}
    const pearlMat=material(0xE0DBBD,.02,.64),copperMat=material(0xBE8C5C,.78,.43);
    pearlMat.bumpMap=micro;pearlMat.bumpScale=.003;copperMat.bumpMap=micro;copperMat.bumpScale=.005;
    [pearlMat,copperMat].forEach((mat,half)=>{
      const beads=new T.InstancedMesh(new T.IcosahedronGeometry(1,1),mat,620);
      for(let i=0;i<620;i++) {
        const angle=random()*Math.PI+half*Math.PI,r=Math.sqrt(.46*.46+random()*(.86*.86-.46*.46)),size=half?.026+random()*.012:.035+random()*.01;
        dummy.position.set(Math.cos(angle)*r,Math.sin(angle)*r,(random()-.5)*.21);dummy.rotation.set(random()*3,random()*3,random()*3);dummy.scale.set(size,size,size);dummy.updateMatrix();beads.setMatrixAt(i,dummy.matrix);beads.setColorAt(i,new T.Color(half?(i%4===0?0xCCD0B9:0xE1AC75):0xFFF5DC));
      }
      s.puck.add(beads);
    });
    for(let i=0;i<8;i++) {const angle=i*Math.PI/4;const strut=mesh(new T.BoxGeometry(.021,.45,.021),polymer,s.puck,Math.cos(angle)*.665,Math.sin(angle)*.665,-.16);strut.rotation.z=angle-Math.PI/2;}
    s.face = new T.Group();s.head.add(s.face);
    const faceMap=texture(1024,(ctx,size)=>{
      ctx.fillStyle='#222C32';ctx.fillRect(0,0,size,size);
      for(let row=0;row<12;row++) {
        const radius=225+row*22,count=Math.floor(radius/5.5);
        for(let i=0;i<count;i++) {const angle=(i+(row%2)*.5)/count*Math.PI*2,x=512+Math.cos(angle)*radius,y=512+Math.sin(angle)*radius;ctx.fillStyle='#576268';ctx.beginPath();ctx.ellipse(x,y+1.5,4,4.6,0,0,Math.PI*2);ctx.fill();ctx.fillStyle='#070E14';ctx.beginPath();ctx.ellipse(x,y-1,3.7,4,0,0,Math.PI*2);ctx.fill();}
      }
    });
    s.faceMaterial=material(0xCFD4D4,.25,.44);s.faceMaterial.map=faceMap;s.faceMaterial.bumpMap=faceMap;s.faceMaterial.bumpScale=.012;s.faceMaterial.transparent=true;
    const faceGeometry=ringGeometry(.982,.388,.06,.018),pos=faceGeometry.attributes.position,uv=faceGeometry.attributes.uv;
    for(let i=0;i<pos.count;i++)uv.setXY(i,pos.getX(i)/2+.5,pos.getY(i)/2+.5);
    mesh(faceGeometry,s.faceMaterial,s.face);
    hoop(.984,.012,s.face,.035,silver);hoop(.392,.011,s.face,.035,silver);
    const nozzlePositions=[];
    for(let row=0;row<12;row++){const radius=(225+row*22)/512,count=Math.floor((225+row*22)/5.5);for(let i=0;i<count;i++){const angle=(i+(row%2)*.5)/count*Math.PI*2;nozzlePositions.push([Math.cos(angle)*radius,Math.sin(angle)*radius]);}}
    s.nozzleMaterial=material(0x27333A,.22,.55);s.nozzleMaterial.transparent=true;
    const nozzles=new T.InstancedMesh(new T.TorusGeometry(.0068,.0017,4,7),s.nozzleMaterial,nozzlePositions.length);
    nozzlePositions.forEach(([x,y],i)=>{dummy.position.set(x,y,.037);dummy.rotation.set(0,0,0);dummy.scale.setScalar(1);dummy.updateMatrix();nozzles.setMatrixAt(i,dummy.matrix);});s.face.add(nozzles);
    const axisGeometry=new T.BufferGeometry().setFromPoints([new T.Vector3(0,1.59,-.2),new T.Vector3(0,1.59,3)]);
    s.axis=new T.Line(axisGeometry,new T.LineDashedMaterial({color:0xB8D0FF,transparent:true,opacity:0,dashSize:.035,gapSize:.055,depthWrite:false}));s.axis.computeLineDistances();root.add(s.axis);

    s.puck.position.z=.10;s.face.position.z=.32;

    // The water travels through the handle, around the head's centre opening, then out.
    s.flow=new T.Group();root.add(s.flow);s.flowMaterial=new T.MeshBasicMaterial({color:0x6EADFF,transparent:true,opacity:0,depthWrite:false,toneMapped:false});
    s.paths=[];
    for(let i=0;i<7;i++) {
      const angle=-Math.PI/2+i*Math.PI*2/7,x=Math.cos(angle)*.70,y=1.59+Math.sin(angle)*.70;
      const points=[new T.Vector3((i-3)*.024,-2.95,0),new T.Vector3((i-3)*.024,-1.3,.03),new T.Vector3((i-3)*.024,.55,.08)];
      for(let j=0;j<=10;j++){const a=-Math.PI/2+(angle+Math.PI/2)*j/10;points.push(new T.Vector3(Math.cos(a)*.70,1.59+Math.sin(a)*.70,.18));}
      points.push(new T.Vector3(x,y,.85),new T.Vector3(x*1.12,y-.15,2.55));
      const path=new T.CatmullRomCurve3(points);
      s.paths.push(path);mesh(new T.TubeGeometry(path,80,.006,5,false),s.flowMaterial,s.flow);
    }
    s.drops=new T.InstancedMesh(new T.SphereGeometry(.016,6,6),new T.MeshBasicMaterial({color:0xF0F4FF,transparent:true,opacity:0,depthWrite:false,toneMapped:false}),70);s.flow.add(s.drops);s.dummy=dummy;
    this.cacheFilterLabels();
    this.filterWidth=0;this.filterHeight=0;
  }
  renderFilterModel(progress) {
    const s=this.filter3D;
    if(!s)return;
    const ramp=(a,b)=>{const t=Math.max(0,Math.min(1,(progress-a)/(b-a)));return t*t*(3-2*t);};
    const handleOpen=ramp(.09,.32),headOpen=ramp(.37,.64),water=ramp(.77,.92);
    const opening=headOpen*(1-.72*water),faceOpen=ramp(.33,.57)*(1-.72*water);
    const handleFocus=handleOpen*(1-headOpen)*(1-water),headFocus=headOpen*(1-water);
    const mobile=this.filterWidth<600;
    s.camera.zoom=this.filterStatic?1:1 + (mobile ? .08 : .14) * handleFocus + (mobile ? .5 : .38) * headFocus;
    const targetY=this.filterStatic ? .1 : .1 - .16 * handleFocus + .82 * headFocus;
    s.camera.position.y=targetY;s.camera.lookAt(0,targetY,0);s.camera.updateProjectionMatrix();s.camera.updateMatrixWorld();
    s.root.rotation.set(-.08+.09*headOpen,.38+.43*headOpen-.23*water+this.filterYaw,-.15+.08*headOpen);
    s.root.position.set(-.2-.56*opening-(mobile ? .32 * headFocus : 0),.04,0);
    s.handle.position.set(-.78*handleOpen*(1-water),-.18*handleOpen*(1-water),-.14*handleOpen);
    s.shellMaterial.opacity=1-.82*handleOpen-.04*water;s.shellMaterial.depthWrite=s.shellMaterial.opacity>.9;
    s.carbon.position.z=.15*handleOpen;
    s.carbonCaps[0].position.y=-1.17-.14*handleFocus;s.carbonCaps[1].position.y=1.17+.16*handleFocus;
    s.carbonSleeve.rotation.y=.2*handleFocus;
    s.puck.visible=headOpen>.005 || water>.001;
    s.puck.position.z=.10+1.16*opening;s.puck.rotation.z=.16*opening;
    s.face.position.z=.32+2.45*faceOpen;s.face.rotation.z=.42*faceOpen;
    s.seal.position.z=.27+1.73*opening;
    s.axis.material.opacity=.23*headFocus;s.axis.visible=headFocus>.001;
    s.headMaterial.opacity=1-.72*water;s.headMaterial.depthWrite=water<.1;
    s.faceMaterial.opacity=1-.79*water;s.faceMaterial.depthWrite=water<.1;s.nozzleMaterial.opacity=1-.79*water;
    s.flow.visible=water>.001;s.flowMaterial.opacity=.58*water;s.drops.material.opacity=.9*water;
    if(water>.001) {
      for(let i=0;i<70;i++){
        const t=(i/70+this.filterClock*.15)%1,path=s.paths[i%7];
        path.getPointAt(t,s.sample);path.getTangentAt(t,s.tangent);
        s.dummy.position.copy(s.sample);s.dummy.quaternion.setFromUnitVectors(s.up,s.tangent);s.dummy.scale.set(1,t>.83?3:1.6,1);s.dummy.updateMatrix();s.drops.setMatrixAt(i,s.dummy.matrix);
      }
      s.drops.instanceMatrix.needsUpdate=true;
    }
    s.root.updateMatrixWorld(true);
    const orbitFade=(1+Math.cos(this.filterYaw))/2;
    let faceRight=0;
    for(let i=0;i<8;i++){
      const a=i*Math.PI/4;s.projected.set(Math.cos(a)*1.04,Math.sin(a)*1.04,.04);
      s.face.localToWorld(s.projected);s.projected.project(s.camera);
      faceRight=Math.max(faceRight,(s.projected.x*.5+.5)*this.filterWidth);
    }
    const label=(name,part,x,y,z,opacity,offsetY=0)=>{
      const node=s.labels[name];if(!node?.element)return;
      s.projected.set(x,y,z);part.localToWorld(s.projected);s.projected.project(s.camera);
      const anchorX=(s.projected.x*.5+.5)*this.filterWidth,anchorY=(-s.projected.y*.5+.5)*this.filterHeight;
      const left=Math.max(28,Math.min(this.filterWidth-node.width-12,Math.max(anchorX+54,name==='scale'||name==='kdf'?faceRight+24:0)));
      const top=Math.max(15,Math.min(this.filterHeight-42,anchorY-8+offsetY));
      const alpha=Math.abs(s.projected.y)>.94?0:opacity*orbitFade;
      node.element.style.opacity=String(alpha);node.element.style.left=left.toFixed(1)+'px';node.element.style.top=top.toFixed(1)+'px';
      node.group.setAttribute('opacity',String(alpha));node.path.setAttribute('d','M'+anchorX.toFixed(1)+' '+anchorY.toFixed(1)+'L'+(left-20).toFixed(1)+' '+(top+7).toFixed(1)+'H'+(left-7).toFixed(1));node.dot.setAttribute('cx',anchorX.toFixed(1));node.dot.setAttribute('cy',anchorY.toFixed(1));
    };
    const overview=this.filterStatic?0:1-Math.max(handleFocus,headFocus);
    label('head',s.face,.76,.65,.1,overview);
    label('handle',s.carbon,.26,-.24,.1,this.filterStatic?1:1-headFocus);
    label('scale',s.puck,.36,.71,.16,mobile?0:this.filterStatic?1:headFocus,-25);
    label('kdf',s.puck,.55,-.57,.16,mobile?0:this.filterStatic?1:headFocus,16);
    s.renderer.render(s.scene,s.camera);
  }
  cacheFilterLabels() {
    const s=this.filter3D;if(!s)return;
    s.labels={};
    for(const name of ['head','handle','scale','kdf']){
      const element=this.filterSection.querySelector('.hf-tag-'+name),group=this.filterSection.querySelector('[data-leader="'+name+'"]');
      if(element && group)s.labels[name]={element,group,path:group.querySelector('path'),dot:group.querySelector('circle'),width:element.offsetWidth};
    }
  }
  initFilterScene() {
    const section=this.filterSection;this.filterObserved=section;
    if(!section)return;
    this.filterToken=Symbol('filter');this.filterLoading=false;this.filterFailed=false;
    this.filterProgress=null;this.filterLastTime=null;this.filterYaw=0;this.filterYawTarget=0;this.filterClock=0;this.filterWaterPaused=false;this.filterActive=null;
    this.filterEvents=new AbortController();const signal=this.filterEvents.signal;
    this.filterStage=section.querySelector('.hf-stage');this.filterHeader=document.querySelector('header');this.filterModuleUrl=section.dataset.threeUrl;
    this.filterVisual=section.querySelector('.hf-visual');this.filterHost=section.querySelector('.hf-canvas-host');
    this.filterChapters=[...section.querySelectorAll('.hf-chapter')];this.filterButtons=[...section.querySelectorAll('.hf-step')];
    this.filterHost.addEventListener('pointerdown',event=>{
      if(!event.isPrimary || event.button!==0 || !this.filter3D || this.filterFailed)return;
      this.filterDrag={id:event.pointerId,x:event.clientX,y:event.clientY,lastX:event.clientX,active:false};
    },{signal});
    this.filterHost.addEventListener('pointermove',event=>{
      const drag=this.filterDrag;if(!drag || drag.id!==event.pointerId)return;
      const dx=event.clientX-drag.x,dy=event.clientY-drag.y;
      if(!drag.active){
        if(Math.abs(dy)>Math.abs(dx) && Math.abs(dy)>7){this.filterDrag=null;return;}
        if(Math.abs(dx)<7)return;
        drag.active=true;this.filterHost.setPointerCapture(event.pointerId);this.filterHost.dataset.dragging='true';
      }
      this.filterYawTarget+=(event.clientX-drag.lastX)*.009;drag.lastX=event.clientX;this.syncFilterScene();
    },{signal});
    const release=event=>{
      if(!this.filterDrag || this.filterDrag.id!==event.pointerId)return;
      if(this.filterHost.hasPointerCapture(event.pointerId))this.filterHost.releasePointerCapture(event.pointerId);
      this.filterDrag=null;delete this.filterHost.dataset.dragging;
    };
    this.filterHost.addEventListener('pointerup',release,{signal});this.filterHost.addEventListener('pointercancel',release,{signal});
    this.filterHost.addEventListener('pointerleave',event=>{if(!this.filterDrag?.active)release(event);},{signal});
    this.filterCompact=window.matchMedia('(max-height: 600px)');
    this.heroMotion.addEventListener('change',this.configureFilterScene,{signal});this.filterCompact.addEventListener('change',this.configureFilterScene,{signal});
    window.addEventListener('scroll',this.syncFilterScene,{passive:true,signal});document.addEventListener('visibilitychange',this.syncFilterScene,{signal});
    this.filterObserver=new IntersectionObserver(([entry])=>{
      this.filterInView=entry.isIntersecting;
      if(entry.isIntersecting){this.loadFilterModel();this.syncFilterScene();}
    },{rootMargin:'650px 0px'});
    this.filterObserver.observe(section);
    this.filterResizeObserver=new ResizeObserver(this.measureFilterScene);
    [section,this.filterStage,this.filterVisual,this.filterHost,this.filterHeader].filter(Boolean).forEach(el=>this.filterResizeObserver.observe(el));
    this.configureFilterScene();
  }
  disposeFilterModel() {
    const s=this.filter3D;if(!s)return;
    const geometries=new Set(),materials=new Set();
    s.scene.traverse(o=>{if(o.geometry)geometries.add(o.geometry);if(o.material)(Array.isArray(o.material)?o.material:[o.material]).forEach(m=>materials.add(m));});
    geometries.forEach(g=>g.dispose());materials.forEach(m=>m.dispose());s.textures.forEach(t=>t.dispose());s.environment?.dispose();
    s.renderer.dispose();s.renderer.domElement.remove();this.filter3D=null;
  }
  destroyFilterScene() {
    this.filterToken=null;window.cancelAnimationFrame(this.filterFrame);this.filterFrame=0;this.filterInView=false;
    this.filterObserver?.disconnect();this.filterResizeObserver?.disconnect();this.filterEvents?.abort();this.disposeFilterModel();
  }
  menuToggleRef = (node) => { this.menuToggle = node; };
  toggleMenu = () => { this.setState({ menuOpen: !this.state.menuOpen }); };
  onNavKeyDown = (event) => {
    if (event.key === 'Escape' && this.state.menuOpen) {
      this.setState({ menuOpen: false }, () => this.menuToggle?.focus());
    }
  };
  siteRef = (node) => { this.site = node; };
  heroVideoRef = (video) => { this.heroVideo = video; };
  heroInView = false;
  heroUserPaused = false;
  selectHeroVideo = () => {
    const mobile = this.heroViewport.matches && this.site.querySelector('.halo-hero-media[data-mobile-media]');
    const video = this.site.querySelector(mobile ? '.halo-home-video--mobile' : '[data-hero-video], .halo-home-video:not(.halo-home-video--mobile)');
    if (video === this.heroVideo) return;
    this.heroVideo?.pause();
    this.heroObserver?.disconnect();
    this.heroVideo = video;
    this.heroInView = !('IntersectionObserver' in window);
    this.setState({ heroVideoReady: false, heroVideoPaused: true });
    if (video) this.heroObserver?.observe(video);
    this.syncHeroPlayback();
  };
  syncHeroPlayback = () => {
    const video = this.heroVideo;
    if (!video) return;
    if (this.heroMotion.matches || document.hidden || !this.heroInView || this.heroUserPaused) {
      video.pause();
      if (this.heroMotion.matches) this.setState({ heroVideoReady: false });
      return;
    }
    video.muted = true;
    video.play().catch(() => {
      // A blocked autoplay or failed download leaves the image in place.
    });
  };
  onHeroPlaying = (event) => {
    if (event && event.target !== this.heroVideo) { event.target.pause(); return; }
    if (this.heroMotion.matches || document.hidden || !this.heroInView || this.heroUserPaused) {
      this.syncHeroPlayback();
      return;
    }
    this.setState({ heroVideoReady: true, heroVideoPaused: false });
  };
  onHeroPause = (event) => { if (!event || event.target === this.heroVideo) this.setState({ heroVideoPaused: true }); };
  onHeroError = (event) => { if (!event || event.target === this.heroVideo) this.setState({ heroVideoReady: false, heroVideoPaused: true }); };
  toggleHeroVideo = () => {
    if (!this.heroVideo) return;
    this.heroUserPaused = !this.heroVideo.paused;
    this.syncHeroPlayback();
  };
  onSiteClick = (event) => {
    if (event.target.closest('.halo-nav a') && this.state.menuOpen) {
      this.setState({ menuOpen: false });
    }
    const control = event.target.closest('.halo-button');
    if (!control || this.heroMotion?.matches) return;
    const rect = control.getBoundingClientRect();
    control.style.setProperty('--ripple-x', `${event.detail ? event.clientX - rect.left : rect.width / 2}px`);
    control.style.setProperty('--ripple-y', `${event.detail ? event.clientY - rect.top : rect.height / 2}px`);
    control.style.setProperty('--ripple-size', `${Math.hypot(rect.width, rect.height) * 2}px`);
    control.removeAttribute('data-rippling');
    // One style flush per activation lets a repeated click start a fresh ripple.
    void control.offsetWidth;
    control.dataset.rippling = 'true';
  };
  onEffectEnd = (event) => {
    if (event.animationName === 'haloRipple') event.target.removeAttribute('data-rippling');
  };
  toggleResults = () => { this.setState({ resultsPaused: !this.state.resultsPaused }); };

  onEnvironmentChange = () => {
    if (this.site) this.site.dataset.documentHidden = String(document.hidden);
    if (this.heroMotion.matches || document.hidden) {
      this.site?.querySelectorAll('[data-rippling]').forEach((node) => node.removeAttribute('data-rippling'));
    }
    this.syncHeroPlayback();
  };
  observeMotion() {
    this.loopObserver?.disconnect();
    this.sectionObserver?.disconnect();
    this.site?.querySelectorAll('[data-loop]').forEach((node) => this.loopObserver?.observe(node));
    this.site?.querySelectorAll('section[id]').forEach((node) => this.sectionObserver?.observe(node));
  }
  componentDidMount() {
    this.heroMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.heroViewport = window.matchMedia('(max-width: 799px)');
    this.heroViewport.addEventListener('change', this.selectHeroVideo);
    this.heroMotion.addEventListener('change', this.onEnvironmentChange);
    document.addEventListener('visibilitychange', this.onEnvironmentChange);
    if ('IntersectionObserver' in window) {
      this.heroObserver = new IntersectionObserver(([entry]) => {
        if (entry.target !== this.heroVideo) return;
        this.heroInView = entry.isIntersecting;
        this.syncHeroPlayback();
      });
      this.loopObserver = new IntersectionObserver((entries) => {
        for (const entry of entries) entry.target.dataset.inView = String(entry.isIntersecting);
      });
      this.sectionObserver = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          for (const link of this.site.querySelectorAll('.halo-nav-links a')) {
            if (link.hash === `#${entry.target.id}`) link.setAttribute('aria-current', 'location');
            else link.removeAttribute('aria-current');
          }
        }
      }, { rootMargin: '-20% 0px -60% 0px' });
      this.observeMotion();
    }
    this.selectHeroVideo();
    this.onEnvironmentChange();
    this.initFilterScene();
    // Return links from the PDP must wait until DC has mounted the sections.
    if (window.location.hash) {
      this.anchorFrame = requestAnimationFrame(() => {
        document.getElementById(window.location.hash.slice(1))?.scrollIntoView({ behavior: 'instant', block: 'start' });
      });
    }
  }
  componentDidUpdate(prevProps) {
    if (this.filterObserved !== this.filterSection || this.filterHost !== this.filterSection?.querySelector('.hf-canvas-host')) {
      this.destroyFilterScene();
      this.initFilterScene();
    } else if (this.filterSection) {
      // DC can replace text-bearing descendants without remounting the section.
      this.filterChapters = [...this.filterSection.querySelectorAll('.hf-chapter')];
      this.filterButtons = [...this.filterSection.querySelectorAll('.hf-step')];
      this.cacheFilterLabels();
      this.measureFilterScene();
      if (this.filterStatic) this.paintFilterScene(.66);
      else this.syncFilterScene();
    }
    if (prevProps.showHardnessTool !== this.props.showHardnessTool || prevProps.showResultsRail !== this.props.showResultsRail) {
      this.observeMotion();
    }
  }
  componentWillUnmount() {
    this.homeEvents?.abort();
    this.destroyFilterScene();
    this.heroObserver?.disconnect();
    this.loopObserver?.disconnect();
    this.sectionObserver?.disconnect();
    this.heroMotion?.removeEventListener('change', this.onEnvironmentChange);
    this.heroViewport?.removeEventListener('change', this.selectHeroVideo);
    document.removeEventListener('visibilitychange', this.onEnvironmentChange);
    cancelAnimationFrame(this.anchorFrame);
    this.heroVideo?.pause();
  }
  renderVals() {
    return {
      filterSceneRef: this.filterSceneRef,
      selectFilterStep: this.selectFilterStep,
      rotateFilterView: this.rotateFilterView,
      resetFilterView: this.resetFilterView,
      toggleFilterWater: this.toggleFilterWater,
      siteRef: this.siteRef,
      menuToggleRef: this.menuToggleRef,
      toggleMenu: this.toggleMenu,
      onNavKeyDown: this.onNavKeyDown,
      menuOpen: this.state.menuOpen,
      menuLabel: this.state.menuOpen ? 'Close' : 'Menu',
      onSiteClick: this.onSiteClick,
      onEffectEnd: this.onEffectEnd,
      toggleResults: this.toggleResults,
      resultsPaused: this.state.resultsPaused,
      resultsToggleText: this.state.resultsPaused ? t('results_play') : t('results_pause'),
      resultsToggleLabel: this.state.resultsPaused ? t('play_results') : t('pause_results'),
      heroVideoRef: this.heroVideoRef,
      heroVideoReady: this.state.heroVideoReady,
      onHeroPlaying: this.onHeroPlaying,
      onHeroPause: this.onHeroPause,
      onHeroError: this.onHeroError,
      toggleHeroVideo: this.toggleHeroVideo,
      heroVideoToggleLabel: this.state.heroVideoPaused ? "Play hero video" : "Pause hero video",
      heroVideoToggleText: this.state.heroVideoPaused ? "Play" : "Pause",
      ctaLabel: this.props.ctaLabel ?? "Shop",
      showHardnessTool: this.props.showHardnessTool ?? true,
      showResultsRail: this.props.showResultsRail ?? true,

    };
  }
}
function destroy(site) {
  const controller = site.__haloHome;
  if (!controller) return;
  controller.componentWillUnmount();
  delete site.__haloHome;
}

function mount(site) {
  if (!site || site.__haloHome) return;
  const controller = new Component();
  controller.site = site;
  controller.filterSection = site.querySelector('.halo-filter');
  controller.menuToggle = site.querySelector('[data-halo-menu-toggle]');
  controller.homeEvents = new AbortController();
  const options = { signal: controller.homeEvents.signal };
  site.addEventListener('click', controller.onSiteClick, options);
  site.addEventListener('animationend', controller.onEffectEnd, options);
  site.querySelectorAll('[data-hero-video], .halo-home-video').forEach((video) => {
    video.addEventListener('playing', controller.onHeroPlaying, options);
    video.addEventListener('pause', controller.onHeroPause, options);
    video.addEventListener('error', controller.onHeroError, options);
  });
  site.querySelector('[data-hero-toggle]')?.addEventListener('click', controller.toggleHeroVideo, options);
  site.querySelector('[data-results-toggle]')?.addEventListener('click', controller.toggleResults, options);
  site.querySelectorAll('[data-filter-step]').forEach((button) => button.addEventListener('click', controller.selectFilterStep, options));
  site.querySelectorAll('[data-filter-turn]').forEach((button) => button.addEventListener('click', controller.rotateFilterView, options));
  site.querySelector('.hf-viewbutton:not([data-filter-turn])')?.addEventListener('click', controller.resetFilterView, options);
  site.querySelector('.hf-water-toggle')?.addEventListener('click', controller.toggleFilterWater, options);
  controller.syncDom();
  controller.componentDidMount();
  site.__haloHome = controller;
}

function remount() {
  document.querySelectorAll('[data-halo-home], .halo-site').forEach((site) => { destroy(site); mount(site); });
}

document.addEventListener('DOMContentLoaded', remount);
document.addEventListener('shopify:section:load', () => requestAnimationFrame(remount));
document.addEventListener('shopify:section:unload', () => requestAnimationFrame(remount));
if (document.readyState !== 'loading') remount();
})();
